export default __webpack_public_path__ + "static/media/EAST2460.34I-34257_-18476_0.41936b0f.jpg";